import React from "react";
import styled from "styled-components";

const LoadingContainer = styled.div`
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  flex-direction: column;
`;

const LoadingContent = styled.div`
  background-color: white;
  border-radius: 8px;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingImage = styled.img`
  width: 70px;
`;

const LoadingText = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
`;

const LoadingProgress = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-top: 5px;
`;

const CloseButton = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
`;

function Loading({ loadingText, progress, showClose, onClose }) {
  return (
    <LoadingContainer>
      <LoadingContent>
        <LoadingImage src="/assets/images/common/loading.gif" alt="로딩중" />
      </LoadingContent>
      {loadingText && <LoadingText>{loadingText}</LoadingText>}
      {progress && <LoadingProgress>{progress.toFixed(0)}%</LoadingProgress>}
      {showClose && (
        <CloseButton onClick={onClose}>
          닫기 (순서지정은 백그라운드에서 계속 진행됩니다)
        </CloseButton>
      )}
    </LoadingContainer>
  );
}

export default Loading;
